<script lang="ts">
	import { classes } from '$lib/utils';
	import HeroCrossDivider from '../Divider/HeroCrossDivider.svelte';

	export let additionalClass: string = '';
</script>

<section class={classes(additionalClass, 'pb-11')}>
	<div
		class="flex flex-col md:grid md:grid-cols-12 bg-none items-baseline pt-11 pb-0 md:pt-48 md:pb-14"
	>
		<slot />
	</div>
	<HeroCrossDivider />
</section>
